import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../lib/analytics';

export const RouteScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    // Track page view on route change (skip admin)
    if (!pathname.startsWith('/admin')) {
      trackPageView(pathname);
    }
  }, [pathname]);
  return null;
};
